import { render, staticRenderFns } from "./text_extension.vue?vue&type=template&id=bb2cda44&scoped=true"
import script from "./text_extension.vue?vue&type=script&lang=js"
export * from "./text_extension.vue?vue&type=script&lang=js"
import style0 from "./text_extension.vue?vue&type=style&index=0&id=bb2cda44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2cda44",
  null
  
)

export default component.exports